export default function navigatorVibrate() {
    if ("navigator" in window) {
        "vibrate" in navigator ? navigator.vibrate(100) : null
    }
}
